var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConsultList = function SvgConsultList(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-250.000000, -358.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Teleconsult",
    transform: "translate(230.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Teleconsult-List",
    transform: "translate(0.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(0.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.959307,6 C21.4993597,6 21.9447022,6.62597208 21.9952267,7.42339607 L22,7.5748113 L22,20.4248436 C22,21.2422484 21.5864253,21.9163031 21.0593837,21.9927753 L20.959307,22 L9.04069304,22 C8.50064033,22 8.05529785,21.3740279 8.00477331,20.5763163 L8,20.4248436 L8,11.5 L12,11.5 L12,6 L20.959307,6 Z M20,17 L13,17 L13,19 L20,19 L20,17 Z M12,17 L10,17 L10,19 L12,19 L12,17 Z M20,13 L13,13 L13,15 L20,15 L20,13 Z M12,13 L10,13 L10,15 L12,15 L12,13 Z M10.5,2 C10.7761424,2 11,2.22385763 11,2.5 L11,10 C11,10.2761424 10.7761424,10.5 10.5,10.5 L5,10.5 L5,14.5 L2.4,11.0333333 C2.14035574,10.687141 2,10.2660738 2,9.83333333 L2,2.5 C2,2.22385763 2.22385763,2 2.5,2 L10.5,2 Z M20,9 L13,9 L13,11 L20,11 L20,9 Z M7.5,7.75 L5.5,7.75 L5.5,9.25 L7.5,9.25 L7.5,7.75 Z M7.5,3.5 L5.5,3.5 L5.5,7 L7.5,7 L7.5,3.5 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConsultList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/consult-list.d87ee120.svg";
export { ForwardRef as ReactComponent };